import { ExclamationCircleFilled } from '@ant-design/icons'
import { Checkbox, ConfigProvider } from 'antd'
import classNames from 'classnames'
import { useState } from 'react'
import { Control, Controller, FieldErrors } from 'react-hook-form'

import { ORANGE_COLOR } from '@/constants/ui'

import { LegalCreationType, PhysicalCreationType } from '../Forms/Forms.config'
import cn from './Checkboxes.module.scss'
import PrivacyPolicyModal from './PrivacyPolicyModal/PrivacyPolicyModal'

const CHECKBOX_THEME = { token: { colorPrimary: ORANGE_COLOR } }

type CheckboxesPropsType = {
  control: Control<PhysicalCreationType | LegalCreationType>
  errors?: FieldErrors<PhysicalCreationType | LegalCreationType>
}

function Checkboxes(props: CheckboxesPropsType) {
  const { control, errors } = props
  const [policyOpen, setPolicyOpen] = useState(false)

  return (
    <div className={cn.checkboxes}>
      <div className={cn.checkboxesItem}>
        <Controller
          name="privacyPolicyAgreement"
          control={control}
          render={({ field }) => (
            <div className={cn.checkboxContainer}>
              <ConfigProvider theme={CHECKBOX_THEME}>
                <Checkbox
                  checked={field.value}
                  onChange={(e) => {
                    if (e.target.checked && !field.value) {
                      setPolicyOpen(true)
                    } else {
                      field.onChange(false)
                    }
                  }}
                  className={classNames(
                    cn.checkbox,
                    errors?.privacyPolicyAgreement && cn.checkboxError
                  )}
                >
                  Я согласен с{' '}
                  <span
                    className={cn.policyLink}
                    onClick={(e) => {
                      e.preventDefault()
                      e.stopPropagation()
                      setPolicyOpen(true)
                    }}
                  >
                    политикой конфиденциальности
                  </span>
                  <span className={cn.requiredMark}> *</span>
                </Checkbox>
              </ConfigProvider>

              <span
                role="alert"
                className={classNames(
                  cn.errorMessage,
                  !errors?.privacyPolicyAgreement && cn.errorMessageHidden
                )}
              >
                {errors?.privacyPolicyAgreement && (
                  <ExclamationCircleFilled className={cn.errorIcon} />
                )}
                {errors?.privacyPolicyAgreement?.message}
              </span>

              <PrivacyPolicyModal
                open={policyOpen}
                onClose={() => setPolicyOpen(false)}
                onAccept={() => field.onChange(true)}
              />
            </div>
          )}
        />
      </div>
    </div>
  )
}

export default Checkboxes
